// Centralized image manifest — all photos verified against Unsplash's stable CDN.
// Reused thoughtfully across pages; each spot chooses the image that fits its
// narrative role.

export const IMG = {
  militaryFamily: "https://images.unsplash.com/photo-1758575514459-8a9b37d68047?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxtaWxpdGFyeSUyMGZhbWlseSUyMGh1Z2dpbmd8ZW58MHx8fHwxNzgzNTYxNjE3fDA&ixlib=rb-4.1.0&q=85",
  handsStacked:   "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxoYW5kc2hha2UlMjBzdXBwb3J0JTIwY29tbXVuaXR5fGVufDB8fHx8MTc4MzU2MTYyOXww&ixlib=rb-4.1.0&q=85",
  communityMeeting: "https://images.unsplash.com/photo-1573164574511-73c773193279?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxkaXZlcnNlJTIwY29tbXVuaXR5JTIwbWVldGluZyUyMGRpc2N1c3Npb258ZW58MHx8fHwxNzgzNTYxNjE3fDA&ixlib=rb-4.1.0&q=85",
  professionalPortrait: "https://images.unsplash.com/photo-1617244147299-5ef406921c35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBhZnJpY2FuJTIwYW1lcmljYW4lMjBtYW4lMjBsZWFkZXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODM1NjE2Mjl8MA&ixlib=rb-4.1.0&q=85",
  networkNodes:   "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMG5ldHdvcmslMjBtYXAlMjBub2Rlc3xlbnwwfHx8fDE3ODM1NjE2MTd8MA&ixlib=rb-4.1.0&q=85",
};

/**
 * Reusable full-width image break section. Use to give visual rest between
 * dense text sections. Provides overlay text if provided.
 */
export function ImageBreak({ src, alt, eyebrow, caption, testId = "image-break", height = "h-[380px] md:h-[460px]" }) {
  return (
    <section className={`relative overflow-hidden ${height}`} data-testid={testId}>
      <img src={src} alt={alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/85 via-navy-deep/40 to-transparent" aria-hidden />
      {(eyebrow || caption) && (
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-[1240px] mx-auto w-full px-6 lg:px-10 pb-10 md:pb-14">
            <div className="max-w-3xl text-cream">
              {eyebrow && <p className="eyebrow text-gold-light">{eyebrow}</p>}
              {caption && (
                <p className="mt-4 font-display font-black text-cream text-2xl md:text-3xl lg:text-4xl leading-tight">
                  {caption}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
